import Layout from 'common/Layout';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRouter = () => {
  const user = useSelector((state) => state.user.response);
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  const isLoggedIn = !!user && !!token;
  const location = useLocation();
  const redirectTo = location.pathname === '/userlogin' ? '/userlogin' : '/signin';
  
  if (!isLoggedIn) {
    // If already on the redirect target, don't Navigate to avoid loop
    if (location.pathname === redirectTo) {
      return null; 
    }
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }}/>;
  }

  return (
    <div>
        <Layout>
          <Outlet />
        </Layout>
    </div>
  );
};

export default PrivateRouter;